import {Routes} from '@angular/router';
import {HomeComponent} from "./pages/home/home.component";
import {ImageResolver} from "./pages/home/image.resolver";

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    resolve: {
      imageData: ImageResolver,
    },
  },
  {
    path: 'get-art',
    loadChildren: () => import('./pages/get-art/routes').then(r => r.routes),
  },
  {
    path: 'get-art/:id',
    loadChildren: () => import('./pages/get-art/routes').then(r => r.routes),
  },
  {
    path: 'thank-you',
    loadComponent: () => import('./pages/get-art/pages/thank-you/thank-you.component').then((c) => c.ThankYouComponent),
  },
  {
    path: 'content/:slug',
    loadComponent: () => import('./pages/content/content.component').then((c) => c.ContentComponent),
  },
  {
    path: 'form',
    loadComponent: () => import('./pages/training-form/training-form.component').then((c) => c.TrainingFormComponent),
  },
  {
    path: 'form-results',
    loadComponent: () => import('./pages/training-form-results/training-form-results.component').then((c) => c.TrainingFormResultsComponent),
  },
  {
    path: 'print',
    loadComponent: () => import('./pages/print/print.component').then((c) => c.PrintComponent),
  },
  {
    path: 'quiz',
    loadComponent: () => import('./pages/quiz/quiz.component').then((c) => c.QuizComponent),
  },
  {
    path: '**',
    loadComponent: () => import('./pages/page-not-found/page-not-found.component').then((c) => c.PageNotFoundComponent)
  },
];
